import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomProductTagsComponent } from './custom-product-tags.component';



@NgModule({
  declarations: [CustomProductTagsComponent],
  imports: [
    CommonModule
  ],
  exports: [CustomProductTagsComponent]
})
export class CustomProductTagsModule { }
